import { render, staticRenderFns } from "./CombinedResultNetAnalysisWidget.vue?vue&type=template&id=bf667772"
import script from "./CombinedResultNetAnalysisWidget.vue?vue&type=script&lang=js"
export * from "./CombinedResultNetAnalysisWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf667772')) {
      api.createRecord('bf667772', component.options)
    } else {
      api.reload('bf667772', component.options)
    }
    module.hot.accept("./CombinedResultNetAnalysisWidget.vue?vue&type=template&id=bf667772", function () {
      api.rerender('bf667772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/ExamReport/CombinedResultNetAnalysisWidget.vue"
export default component.exports